module.exports = __webpack_public_path__ + "img/OLAB.fe59d66f.svg";